import React from 'react';

function Home_Hackathons() {
  return (
    <div className="max-w-screen-xl	mx-auto text-center">
      <main className="mt-10">
        <p className="font-bold text-sm py-6">HACKATHONS</p>
        <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-around md:items-center md:justify-center sm:items-center sm:justify-center py-10 px-0">
          <div className="lg:w-6/12 md:w-6/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-1">
              <img src={require('../../common/images/home/award.svg')} alt="Award Art" className="h-auto w-full" />
            </div>
            <em className="mt-10 mb-2 text-gray-600">Finalist</em>
            <p className="text-base font-bold text-indigo-900">ADB-AIM Hack 2018</p>
            <p className="text-sm text-gray-600">Manila, Philippines | Aug 2018</p>
          </div>
          <div className="lg:w-6/12 md:w-6/12 sm:w-full w-full flex flex-col justify-center items-center">
            <div className="px-1">
              <img src={require('../../common/images/home/award.svg')} alt="Award Art" className="h-auto w-full" />
            </div>
            <em className="mt-10 mb-2 text-gray-600">Finalist</em>
            <p className="text-base font-bold text-indigo-900">Turku Business Region Ultrahack</p>
            <p className="text-sm text-gray-600">Turku, Finland | Oct 2018</p>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Home_Hackathons;
